import { Check } from "lucide-react";
import { SectionHeader } from "@/components/landing/shared";
import { SiteCTA } from "./shared";

const GROUPS = [
  {
    label: "Legal & professional",
    trades: [
      "Personal Injury Law", "Family Law", "Criminal Defense", "Estate Planning",
      "Immigration Law", "Accounting & CPA", "Financial Advisors", "Insurance",
      "Real Estate", "Business Consulting", "Bankruptcy Law", "Employment Law",
    ],
  },
  {
    label: "Medical & dental",
    trades: [
      "Dentists", "Orthodontics", "Chiropractors", "Physical Therapy", "Optometry",
      "Dermatology", "Mental Health", "Primary Care", "Podiatry", "ENT", "Fertility", "Pediatrics",
    ],
  },
  {
    label: "Med spa & wellness",
    trades: [
      "Med Spas", "Botox & Fillers", "Laser & Skin", "IV Therapy", "Weight Loss",
      "Hormone / TRT", "Massage", "Acupuncture", "Salons & Barbers", "Lash & Brow", "Hair Restoration", "Wellness",
    ],
  },
  {
    label: "Home & local services",
    trades: [
      "HVAC", "Roofing", "Plumbing", "Electrical", "Remodeling", "Landscaping",
      "Pest Control", "Auto Detailing", "Dog Grooming", "Cleaning", "Garage Doors", "Pool Service",
    ],
  },
];

const Chip = ({ children, testId }) => (
  <span
    data-testid={testId}
    className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white px-4 py-2 text-sm font-medium text-navy/80 shadow-[0_2px_8px_-4px_rgba(14,18,48,0.10)] transition-transform duration-200 hover:-translate-y-0.5"
  >
    <span className="flex h-4 w-4 items-center justify-center rounded-full bg-brand-gradient">
      <Check className="h-2.5 w-2.5 text-white" strokeWidth={3} />
    </span>
    {children}
  </span>
);

// Site variant of WhoItsFor — same niche chips, CTA books a call instead of the
// old lead modal.
export default function SiteNiches() {
  return (
    <section data-testid="who-its-for-section" className="bg-mist py-16 sm:py-24">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <SectionHeader
          eyebrow="Who it's for"
          title={<>Built for busy local <span className="text-gradient">practices &amp; businesses.</span></>}
          subtitle="If you rely on a full schedule — consults, appointments, new clients — this is for you. A few of the practices and businesses we grow every day:"
        />

        <div className="mt-10 grid gap-8 sm:mt-12 sm:grid-cols-2">
          {GROUPS.map((g) => (
            <div
              key={g.label}
              data-testid={`trade-group-${g.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="rounded-3xl border border-slate-100 bg-white p-6 sm:p-8"
            >
              <p className="font-mono text-[11px] font-bold uppercase tracking-[0.18em] text-brand-indigo">
                {g.label}
              </p>
              <div className="mt-5 flex flex-wrap gap-2.5">
                {g.trades.map((t) => (
                  <Chip key={t} testId={`trade-chip-${t.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
                    {t}
                  </Chip>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col items-start gap-3 sm:flex-row sm:items-center sm:gap-5">
          <p className="text-base text-navy/60 sm:text-lg">
            Don&apos;t see your practice? If you take appointments, we can fill your calendar.
          </p>
          <SiteCTA href="/contact" testId="who-its-for-cta">See if you&apos;re a fit</SiteCTA>
        </div>
      </div>
    </section>
  );
}
